"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _logger = _interopRequireDefault(require("../utils/logger"));
class ErrorBoundary extends _react.Component {
  /**
   * Initialize the class.
   * @param {Object} props the props
   */
  constructor(props) {
    super(props);
    this.checkProps = _ref => {
      let {
        fallback,
        onError
      } = _ref;
      if (!fallback && !onError) {
        _logger.default.warn('No fallback or onError event passed to Error Boundary');
      }
    };
    this.checkProps(props);
    this.state = {
      hasError: false,
      errorMessage: null
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    this.checkProps(nextProps);
  }
  componentDidCatch(error, errorInfo) {
    const {
      onError,
      logFatal,
      logErrors
    } = this.props;
    if (logErrors) {
      const logLevel = logFatal ? 'fatal' : 'error';
      _logger.default[logLevel]("ErrorCaught: ".concat(error.message), errorInfo.componentStack);
    }
    if (onError) onError(error, !!logFatal);
    const errorWithoutStack = error.message && error.message.split('\n')[0];
    this.setState({
      hasError: true,
      errorMessage: errorWithoutStack
    });
  }
  render() {
    const {
      fallback: Fallback,
      children
    } = this.props;
    const {
      hasError,
      errorMessage
    } = this.state;
    if (hasError) {
      if (Fallback) {
        return /*#__PURE__*/_react.default.createElement(Fallback, {
          errorMessage: errorMessage
        });
      }
      return null;
    }
    // Normally, just render children
    return children;
  }
}
ErrorBoundary.defaultProps = {
  logErrors: true,
  logFatal: false
};
var _default = exports.default = ErrorBoundary;